export default {
  name: "pro-chiose-right",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    onDeleteAll() {
      let checkedList = [...this.value];
      checkedList.forEach(v => v.isCheck = false);
      this.$emit("onClearAll");
      this.$emit("input", []);
    },
    onDelete(item) {
      item.isCheck = false;
      let checkedList = [...this.value];
      let index = checkedList.findIndex(v => v.id === item.id);
      if (index > -1) {
        checkedList.splice(index, 1);
      }
      this.$emit("onClearOne", item);
      this.$emit("input", checkedList);
    }
  }
};